import { frontendURL } from '../../../helper/URLHelper';
const MiEquipoView = () => import('./MiEquipoProductionView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/mi-equipo'),
      name: 'mi_equipo_view',
      component: MiEquipoView,
      meta: { permissions: ['administrator', 'agent'] },
    },
    {
      path: frontendURL('accounts/:accountId/rrhh'),
      name: 'rrhh_view',
      redirect: to => ({ name: 'mi_equipo_view', params: to.params }),
      meta: { permissions: ['administrator', 'agent'] },
    },
  ],
};
